




















































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("login");
import _ from "lodash";

export default Vue.extend({
    name: "RegistrationInfoCell",
    props: {
        info: {
            type: Object,
            default: function() {
                return {};
            }
        },
        isForeign: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(["loggedIn"]),
        isNewUser() {
            return _.keys(this.info.registrationInfo).length === 0;
        },
        studentEnrollment() {
            if (_.keys(this.info.registrationInfo).length > 0 && this.info.registrationInfo.plan) {
                return this.info.registrationInfo.plan;
            }
            return {};
        }
    },
    methods: {
        safeGo(path: string): string {
            return this.loggedIn ? path : "/login";
        }
    }
});
